import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { COMPANY } from '../config/company';

const IS_DEV = process.env.NODE_ENV === 'development';

const DEMO_USERS = [
  { label: 'Admin',     role: 'admin',     email: 'admin@prasilabs.com',   password: 'Admin@123'   },
  { label: 'Manager',   role: 'manager',   email: 'nisha@prasilabs.com',    password: 'Manager@123' },
  { label: 'Manager',   role: 'manager',   email: 'manish@prasilabs.com',   password: 'Manager@123' },
  { label: 'BD',        role: 'bd',        email: 'rahul@prasilabs.com',    password: 'BD@12345'    },
  { label: 'BD',        role: 'bd',        email: 'pooja@prasilabs.com',    password: 'BD@12345'    },
  { label: 'MR',        role: 'mr',        email: 'karan@prasilabs.com',    password: 'MR@12345'    },
  { label: 'MR',        role: 'mr',        email: 'arjun@prasilabs.com',    password: 'MR@12345'    },
  { label: 'MR (HR)',   role: 'mr',        email: 'sunita@prasilabs.com',   password: 'MR@12345'    },
  { label: 'Scientist', role: 'scientist', email: 'sanjay@prasilabs.com',   password: 'Sci@12345'   },
  { label: 'Scientist', role: 'scientist', email: 'rohit@prasilabs.com',    password: 'Sci@12345'   },
];

export default function Login() {
  const { login } = useAuth();
  const [form, setForm] = useState({ identifier: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.identifier, form.password);
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 50%, #f1f5f9 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Card */}
        <div style={{ background: '#fff', borderRadius: 18, boxShadow: '0 20px 40px rgba(29,78,216,0.1)', overflow: 'hidden' }}>
          {/* Header */}
          <div style={{ background: 'linear-gradient(135deg, #1d4ed8, #3b82f6)', padding: '36px 36px 28px', textAlign: 'center' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, background: 'rgba(255,255,255,0.2)', borderRadius: 14, marginBottom: 14 }}>
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M7 14h4v7H7v-7zM12 7h4v14h-4V7zM17 10h4v11h-4V10z" fill="white" opacity="0.9"/>
                <circle cx="22" cy="8" r="3" fill="#93c5fd"/>
              </svg>
            </div>
            <h1 style={{ color: '#fff', fontSize: '1.5rem', fontWeight: 800, marginBottom: 4 }}>{COMPANY.shortName}</h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.875rem' }}>Pharma CRM System</p>
          </div>

          {/* Form */}
          <div style={{ padding: '30px 36px 36px' }}>
            <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 22 }}>Sign in to your account</h2>

            {error && (
              <div className="alert alert-error" style={{ marginBottom: 18 }}>
                <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email / Phone / Username</label>
                <input type="text" className="form-control" placeholder="email, phone number, or username"
                  value={form.identifier} onChange={e => setForm(p => ({...p, identifier: e.target.value}))} required />
              </div>

              <div className="form-group" style={{ marginBottom: 22 }}>
                <label className="form-label">Password</label>
                <div style={{ position: 'relative' }}>
                  <input type={showPass ? 'text' : 'password'} className="form-control" placeholder="••••••••"
                    value={form.password} onChange={e => setForm(p => ({...p, password: e.target.value}))} required
                    style={{ paddingRight: 40 }} />
                  <button type="button" onClick={() => setShowPass(!showPass)}
                    style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', display: 'flex' }}>
                    {showPass
                      ? <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                      : <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                    }
                  </button>
                </div>
              </div>

              <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
                {loading ? <><div className="spinner" style={{ width: 16, height: 16 }} /> Signing in…</> : 'Sign In'}
              </button>
            </form>

            {IS_DEV && (
              <div style={{ marginTop: 24, padding: '14px 16px', background: '#fffbeb', border: '1px dashed #f59e0b', borderRadius: 10 }}>
                <div style={{ fontSize: '0.7rem', fontWeight: 800, color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 10 }}>
                  Dev — Demo Accounts
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                  {DEMO_USERS.map((u, i) => {
                    const roleColors = {
                      admin:     { bg: '#dbeafe', text: '#1e40af' },
                      manager:   { bg: '#d1fae5', text: '#065f46' },
                      bd:        { bg: '#ede9fe', text: '#5b21b6' },
                      mr:        { bg: '#fef3c7', text: '#92400e' },
                      scientist: { bg: '#fce7f3', text: '#9d174d' },
                    };
                    const c = roleColors[u.role] || { bg: '#f3f4f6', text: '#374151' };
                    return (
                      <button key={i} type="button"
                        onClick={() => setForm({ identifier: u.email, password: u.password })}
                        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', background: '#fff', border: '1px solid #fde68a', borderRadius: 7, cursor: 'pointer', textAlign: 'left' }}>
                        <span style={{ fontSize: '0.68rem', fontWeight: 700, padding: '2px 7px', borderRadius: 4, background: c.bg, color: c.text, minWidth: 62, textAlign: 'center', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                          {u.label}
                        </span>
                        <span style={{ fontSize: '0.75rem', color: '#92400e', fontFamily: 'monospace', flex: 1 }}>{u.email}</span>
                        <span style={{ fontSize: '0.68rem', color: '#a16207', fontFamily: 'monospace' }}>{u.password}</span>
                      </button>
                    );
                  })}
                </div>
                <div style={{ fontSize: '0.68rem', color: '#a16207', marginTop: 8 }}>Click a row to fill credentials, then Sign In.</div>
              </div>
            )}
          </div>
        </div>

        <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.8rem' }}>
          <Link to="/" style={{ color: 'var(--primary)', textDecoration: 'none', fontWeight: 500 }}>
            ← Visit {COMPANY.shortName} Website
          </Link>
        </p>
        <p style={{ textAlign: 'center', marginTop: 10, fontSize: '0.75rem', color: 'var(--text-muted)' }}>
          &copy; {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
        </p>
      </div>
    </div>
  );
}
